import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  plan: string;
  minutes: number;
}
const purchases: Purchase[] = [{
  name: 'Marcela G.',
  city: 'Buenos Aires',
  plan: 'Plan Premium',
  minutes: 2
}, {
  name: 'Laura S.',
  city: 'Córdoba',
  plan: 'Plan Base',
  minutes: 4
}, {
  name: 'Roberto F.',
  city: 'Rosario',
  plan: 'Plan Base',
  minutes: 7
}, {
  name: 'Daniela M.',
  city: 'Rosario',
  plan: 'Plan Base',
  minutes: 11
}, {
  name: 'Valeria P.',
  city: 'Mendoza',
  plan: 'Plan Premium',
  minutes: 15
}, {
  name: 'Carolina B.',
  city: 'La Plata',
  plan: 'Plan Premium',
  minutes: 19
}];
export function SocialProofToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const firstShow = setTimeout(() => setVisible(true), 3500);
    return () => clearTimeout(firstShow);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    const cycleTimer = setTimeout(() => {
      setIndex(i => (i + 1) % purchases.length);
      setVisible(true);
    }, 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(cycleTimer);
    };
  }, [visible, index, dismissed]);
  if (dismissed) return null;
  const p = purchases[index];
  return <div className="fixed bottom-4 left-4 z-40 pointer-events-none max-w-[calc(100%-2rem)]" data-id="element-228">
      <AnimatePresence mode="wait" data-id="element-229">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -30,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -30
      }} transition={{
        duration: 0.4
      }} className="pointer-events-auto bg-white rounded-xl shadow-2xl shadow-teal-900/15 border border-stone-100 p-4 pr-9 w-72 relative" data-id="element-230">
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-stone-400 hover:text-stone-600 transition-colors" data-id="element-231">
              <X className="w-4 h-4" data-id="element-232" />
            </button>

            <div className="flex items-center gap-2 mb-1.5" data-id="element-233">
              <span className="w-2 h-2 rounded-full bg-teal-500 animate-pulse" data-id="element-234" />
              <span className="text-[11px] font-bold tracking-wider uppercase text-teal-600" data-id="element-235">
                Nueva familia unida
              </span>
            </div>

            <p className="text-sm text-teal-900 font-semibold leading-tight" data-id="element-236">
              {p.name}{' '}
              <span className="font-normal text-stone-500" data-id="element-237">de {p.city}</span>
            </p>
            <p className="text-sm text-stone-600" data-id="element-238">
              compró el{' '}
              <span className="font-semibold text-amber-600" data-id="element-239">{p.plan}</span>
            </p>
            <p className="text-[11px] text-stone-400 mt-1.5 uppercase tracking-wide" data-id="element-240">
              Hace {p.minutes} minutos
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}